import React /* useState*/ from "react";
import { connect } from "react-redux";

import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select } from "antd";

import FormPermissionsTemplate from "./form-permissions-template";
import { FormattedMessage } from "react-intl";

const { Option } = Select;
const FormSettings = props => {
  const {
    changeToggle,
    companyUuidSelected,
    companiesLoaded,
    companyChosenList,
    currentPermissions: { isPermissionsSaving, permissionClient },
    resetAll,
    saveAll,
    settings,
    changeInSettings
  } = props;

  const renderFormSettings = () => {
    let children = [];
    if (companiesLoaded) {
      for (let i = 0; i < companiesLoaded.length; i++) {
        children.push(<Option key={companiesLoaded[i].uuid} value={companiesLoaded[i].uuid}>
          {companiesLoaded[i].ragioneSociale}
        </Option>);
      }
    }

    // risolve problema di renderizzazione precoce
    if (permissionClient.companyId !== companyUuidSelected) {
      return (
        <div style={{ textAlign: "center" }}>
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            spin
            style={{ color: "#46a5db", fontSize: "50px" }}
          />
        </div>
      );
    }

    return (
      <div>
        {/** Oscuriamo temporaneamente la select per la selezione multipla delle aziende */}
        {/* <div style={{ marginBottom: "20px" }} className="companySelectSettings">
          <Select
            mode="multiple"
            style={{ width: "625px" }}
            placeholder="Seleziona un'azienda dalla lista"
            value={companyChosenList}
            removeIcon={customRemoveIcon()}
            showArrow={true}
            onChange={handleChangeMultiple.bind(this)}
            filterOption={false}
            onPopupScroll={e => {
              e.persist();
              let target = e.target;
              if (
                companySettingsList.hasMoreItems &&
                target.scrollTop + target.offsetHeight === target.scrollHeight
              ) {
                companiesLoad(companiesPage + 1, "");
                setCompaniesPage(companiesPage + 1);
              }
            }}
            onSearch={value => {
              if (value.length > 3) {
                companiesLoad(0, value);
              } else if (value.length === 3 || value.length === 0) {
                companiesLoad(companiesPage, "");
              }
            }}
          >
            {children}
            {companySettingsList.status.started && (
              <Option key={"spinner"}>
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                  <FontAwesomeIcon
                    icon={["far", "circle-notch"]}
                    spin
                    style={{ color: "#46a5db", fontSize: "50px" }}
                  />
                </div>
              </Option>
            )}
          </Select>
        </div> */}
        {/** se almeno una company è selezionata allora sto aspettando i settings
                    per poi renderizzare quindi visualizzo lo spinner per simboleggiare l'attesa di qualcosa */

          /* arraySettings.length === 0 && */ companyChosenList.length === 0 ? (
            <div style={{ textAlign: "center" }}>
              <FontAwesomeIcon
                icon={["far", "circle-notch"]}
                spin
                style={{ color: "#46a5db", fontSize: "50px" }}
              />
            </div>
          ) : (
            <FormPermissionsTemplate
              permissionClient={permissionClient}
              settings={settings}
              changeToggle={changeToggle}
            />
          )}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="riepilogoPermessi">
        {permissionClient.status.ended ? (
          <div>{renderFormSettings()}</div>
        ) : (
          <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
        )}
      </div>
      <div
        style={{
          textAlign: "center",
          overflow: "hidden",
          height: "100px"
        }}
      >
        {!isPermissionsSaving && companyChosenList.length > 0 ? (
          <div style={{ float: "right" }}>
            <Button
              id="buttonCancelSettings"
              style={{
                width: "119px",
                height: "61px",
                borderRadius: "2px",
                marginRight: "40px",
                top: "20px",
                border: "solid 1px #0090d1",
                backgroundColor: "#f2f5f8"
              }}
              type="submit"
              colorScheme="ghost"
              onClick={resetAll.bind(this)}
              disabled={!changeInSettings}
            >
              <FormattedMessage id="generic.cancel" />
            </Button>

            <Button
              id="buttonApplySettings"
              className="gs-settings-apply"
              style={{
                width: "199px",
                height: "61px",
                marginRight: "40px",
                top: "20px",
                borderRadius: "2px"
              }}
              type="submit"
              onClick={saveAll.bind(this)}
              disabled={!changeInSettings}
            >
              <FormattedMessage id="actions.apply" />
            </Button>
          </div>
        ) : companyChosenList.length > 0 ? (
          <FontAwesomeIcon
            icon={["far", "circle-notch"]}
            spin
            style={{ color: "#46a5db", fontSize: "50px" }}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    auth: state.auth,
    currentPermissions: state.currentPermissions
  };
}

export default connect(mapStateToProps, null)(FormSettings);
